import axios from "axios";
import {useState} from "react";
import Swal from 'sweetalert2';
import {baseUrl} from './Univ.js';
import {useAuth} from '../context/AuthContext';
function ChangePassword() {
    const userId = localStorage.getItem('username');
    const [userData, setuserData] = useState({
        "password": '',
    });
    const {logoutUser} = useAuth();
    const handleChange = (event) => {
        setuserData({
            ...userData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = async () => {
        const userFormData = new FormData();
        userFormData.append("password", userData.password);
        try {
            const response = await axios.post(`${baseUrl}change-pass/${userId}/`, userFormData);
            if (response.status === 200) {
                Swal.fire({
                    title: 'Password Changed Successfully',
                    icon: 'success',
                    timer: 10000,
                    showConfirmButton: false
                });
                // Logout the user
                logoutUser();
                setTimeout(() => {
                    window.location.href = '/user-login/';
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to change password',
                icon: 'error',
            });
        }
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-3 col-12 mb-2"></div>
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Change Password</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="newPassword" className="form-label">New Password</label>
                                    <input type="password" className="form-control" name="password"
                                           value={userData.password} onChange={handleChange} id="password"/>
                                </div>
                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default ChangePassword;
